export const imageUploadAttributes = `
  id
  image {
    filename
    width
    height
  }
  status
  license
  event {
    id
    name
    startAt
    endAt
    timezone
  }
  group {
    id
    slug
    name
  }
  createdByUser {
    id
    username
    displayName
    avatar {
      small {
        url
      }
    }
  }
  permissions {
    editable
  }
  createdAt
`;
